import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const routes = [
  {
    id: 1,
    from: "Ertiga",
    image: "/images/ourfleet/2.jpg",
    days: "Spacious and powerful SUV for rugged terrain and comfort",
  },
  {
    id: 2,
    from: "Aura",
    image: "/images/ourfleet/8.jpg",
    days: "Stylish and fuel-efficient sedan for city drives",
  },
  {
    id: 3,
    from: "Swift Dzire",
    image: "/images/ourfleet/1.jpg",
    days: "Perfect compact sedan for daily commuting",
  },
  {
    id: 4,
    from: "Tempo Traveller",
    image: "/images/ourfleet/6.jpg",
    days: "Ideal for group travel and family road trips",
  }
];

const FlightRouteCard = ({ from, image,days }) => (
  <div className="slider-card-wrapper">
    <div className="slider-card shadow-sm">
      <img src={image} alt={from} className="car-image" />
      <div className="slider-card-body">
        <h5 className="car-title">{from}</h5>
        <p className="car-desc">{days}</p>
        <a href="/booking" className="btn btn-primary btn-sm w-100 mt-2">Book Now</a>
      </div>
    </div>
  </div>
);

const HotInternationalRoutes = () => {
  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3500,
    speed: 800,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  };

  return (
    <section className="py-5" style={{backgroundColor:'#2684C4'}}>
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="fw-bold">Our Most Booked Cars</h2>
          <p className="text-dark">Explore top-rated rides ideal for every kind of journey.</p>
        </div>
        <Slider {...settings}>
          {routes.map(route => (
            <FlightRouteCard key={route.id} {...route} />
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default HotInternationalRoutes;
